import { styled } from '@mui/material/styles';

export const Footer = styled('footer')`
  max-width: 1200px;
  margin-top: auto; // Pushes footer to bottom of the page when there's less body content
  text-align: center;
  text-wrap: balance;
`;
